import { ETAT_PLANIFIE, ETAT_REALISE, ETAT_EN_COURS } from '@/configuration/logistique/audit/auditConf';

export default function genererCritereRecherche() {
  return {
    codes: [],
    otEtat: [ETAT_PLANIFIE, ETAT_REALISE, ETAT_EN_COURS],
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    datesValidite: {
      dateDebut: null,
      dateFin: null,
    },
    sansDatePremierAffichage: false,
    auditeur: [],
    themes: [],
    agencesId: [],
  };
}
